import { create, show, useModal } from "@ebay/nice-modal-react";

import ConfirmationModal from "ds/components/ConfirmationModal";
import { ConfirmationModalMessage } from "ds/components/ConfirmationModal/Message";

type DeleteConfirmationProps = {
  onConfirm: () => void;
  name: string;
};

const DeleteConfirmation = create(function DeleteConfirmation({
  onConfirm,
  name,
}: DeleteConfirmationProps) {
  const modal = useModal();

  const handleOnConfirm = () => {
    modal.resolve();
    modal.hide();
    onConfirm();
  };

  return (
    <ConfirmationModal
      title="Delete Slack access"
      confirmationButtonLabel="Delete"
      confirmationButtonVariant="dangerPrimary"
      onConfirm={handleOnConfirm}
    >
      <ConfirmationModalMessage>
        Are you sure you want to remove <strong>{name}</strong> Slack access?
      </ConfirmationModalMessage>
    </ConfirmationModal>
  );
});

export const showDeleteConfirmation = (props: DeleteConfirmationProps) =>
  show(DeleteConfirmation, props);
